import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ApplicationCompletedGuardService } from './core/guards/application-completed-guard.service';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'static',
    loadChildren: () =>
      import('./static/static.module').then((m) => m.StaticModule),
  },
  {
    path: 'member-application',
    loadChildren: () =>
      import('./applications/member-application/member-application.module').then((m) => m.MemberApplicationModule),
  },
  {
    path: 'provider-application',
    loadChildren: () =>
      import('./applications/provider-application/provider-application.module').then((m) => m.ProviderApplicationModule),
  },
  {
    path: 'agent-group-application',
    loadChildren: () =>
      import('./applications/agent-group-application/agent-group-application.module').then((m) => m.AgentGroupApplicationModule),
  },
  {
    path: 'apply',
    redirectTo: '/member-application/application-form'
  },
  {
    path: 'provider-apply',
    redirectTo: '/provider-application/application-form'
  },
  {
    path: 'agent-group-apply',
    redirectTo: '/agent-group-application/application-form'
  },
  {
    path: 'member',
    loadChildren: () =>
      import('./portals/member/member.module').then((m) => m.MemberModule),
    canActivate: [ApplicationCompletedGuardService]
  },
  {
    path: 'funder',
    loadChildren: () =>
      import('./portals/funder/funder.module').then((m) => m.FunderModule),
  },
  {
    path: 'provider',
    loadChildren: () =>
      import('./portals/provider/provider.module').then(
        (m) => m.ProviderModule
      ),
  },
  {
    path: 'company',
    loadChildren: () =>
      import('./portals/company/company.module').then(
        (m) => m.CompanyModule
      ),
  },
  {
    path: 'agent-group',
    loadChildren: () =>
      import('./portals/agent-group/agent-group.module').then(
        (m) => m.AgentGroupModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
